import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs from "../../../app/lang/langs";
import { InputField } from "../../inputs/InputField";
import { DynamicButton } from "../../buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import moment from "moment";
import { markNewsAsRead, setNewsList } from "../../../containers/dashboard/dashboardSlice";


export default function NewsModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [updatedItem, setUpdatedItem] = useState(props.selectedNews)

    const userId = useSelector((state) => state.login.userId)
    const newsList = useSelector((state) => state.dashboard.news)

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }

    useEffect(() => {
        setUpdatedItem({
            ...props.selectedNews
        })
        if (props.selectedNews && !props.selectedNews.seen && props.selectedNews.id) {
            handleMarkAsRead()
        }
    }, [props.selectedNews])
    
    const handleMarkAsRead = async () => {
        let results = await dispatch(markNewsAsRead({
            newsId: props.selectedNews.id,
            userId: userId
        })).unwrap()
        if (results) {
            let updatedNewsList = newsList.map(news => {
                if (news.id === props.selectedNews.id) {
                    return { ...news, seen: moment().format("YYYY-MM-DD HH:mm:ss") };
                }
                return news;
            });
            dispatch(setNewsList(updatedNewsList))
        }
    }

    const visibleFields = [
        { key: "title", type: "string", disabled: true },
        { key: "message", type: "text", disabled: true, auto: true },
        { key: "created_by", type: "string", disabled: true },
        { key: "created_at", type: "date:time", disabled: true },
    ]

    const handleSave = async () => {

    }

    const footer = () => {
        if (JSON.stringify(props.selectedNews) != JSON.stringify(updatedItem))
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="Save" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
    }

    return (
        <Dialog
            visible={props.selectedNews}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                props.onHide()
            }}
            header={<Langs str="Actualité" />}
            draggable={false}
            dismissableMask={false}
            footer={footer}
        >
            {visibleFields.map(field => <InputField field={field}
                onChange={(e) => handleFieldChange(e, field)}
                value={updatedItem && updatedItem[field.key]} />
            )}
        </Dialog>
    )
}